import { makeStyles } from "@material-ui/core/styles";

const style = makeStyles((theme) => ({
  selectDates: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "space-around",
    padding: "5px",
  },
}));

export default style;
